import { useState } from "react";

import { BRAND_YELLOW, SKILLS } from "../data";

export default function Skills() {
  const [activeName, setActiveName] = useState(SKILLS[0].name);
  const active = SKILLS.find((s) => s.name === activeName) || SKILLS[0];

  return (
    <div className="max-w-5xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Skills</h1>
      <p className="text-gray-500 mb-8 max-w-2xl">
        Skills coach Claude on Jobego-specific workflows. Each one encodes recruiter judgment — which tools to chain, what tone to use, what to output.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-[260px_1fr] gap-8">
        <aside className="space-y-1">
          {SKILLS.map((s) => {
            const isActive = s.name === activeName;
            return (
              <button
                key={s.name}
                onClick={() => setActiveName(s.name)}
                className={`w-full text-left px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive
                    ? "bg-primary/10 text-primary border-l-3 border-primary"
                    : "text-gray-700 hover:bg-gray-50"
                }`}>
                <div className="font-semibold">{s.title || s.name}</div>
                <div className="text-xs text-gray-500 mt-0.5 truncate">{s.name}</div>
              </button>
            );
          })}
        </aside>

        <div>
          <div className="flex items-center gap-3 mb-3">
            <h2 className="text-xl font-bold text-gray-900">{active.title || active.name}</h2>
            <StatusBadge status={active.status} />
          </div>
          <code className="inline-block font-mono text-xs text-gray-500 mb-5">{active.name}</code>
          <p className="text-sm text-gray-700 leading-relaxed mb-4">{active.description}</p>
          {active.details && (
            <p className="text-sm text-gray-600 leading-relaxed">{active.details}</p>
          )}
        </div>
      </div>
    </div>
  );
}

function StatusBadge({ status }) {
  if (status === "available") {
    return (
      <span
        className="text-[10px] font-extrabold uppercase tracking-widest text-black border-2 border-black rounded px-1.5 py-0.5"
        style={{ backgroundColor: BRAND_YELLOW }}>
        Available
      </span>
    );
  }
  return (
    <span className="text-[10px] font-extrabold uppercase tracking-widest text-gray-500 border border-gray-300 rounded px-1.5 py-0.5">
      Coming soon
    </span>
  );
}
